import { useTranslation } from 'react-i18next';

export const useTabs = () => {
  const { t } = useTranslation();

  return [
    { label: t('common.labels.details'), to: '../details' },
    { label: t('pages.roles.tabs.users'), to: '../users' },
    { label: t('common.labels.devices'), to: '../devices' },
    { label: t('pages.roles.tabs.show_folders'), to: '../show-folders' },
    { label: t('pages.roles.tabs.playlist_folders'), to: '../playlist-folders' },
    { label: t('pages.roles.tabs.content_folders'), to: '../content-folders' },
    { label: t('pages.roles.tabs.design_folders'), to: '../design-folders' },
    { label: t('pages.roles.tabs.data_sources'), to: '../data-sources' },
    { label: t('pages.roles.tabs.event_types'), to: '../event-types' },
    { label: t('common.tabs.audit_logs'), to: '../audit-logs' },
  ];
};
